module.exports = __webpack_public_path__ + "static/media/click.441910a5.mp3";